// GDPR consent gate for client-side telemetry (Sentry).
// Stored in localStorage. Default = "pending" → no telemetry until user decides.

export type ConsentState = "pending" | "granted" | "denied";

const KEY = "telemetry-consent-v1";
const listeners = new Set<(s: ConsentState) => void>();

export function getConsent(): ConsentState {
  if (typeof window === "undefined") return "pending";
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "granted" || v === "denied" ? v : "pending";
  } catch {
    return "pending";
  }
}

export function setConsent(state: Exclude<ConsentState, "pending">) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, state);
  } catch {
    // ignore
  }
  listeners.forEach((l) => l(state));
}

export function resetConsent() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  listeners.forEach((l) => l("pending"));
}

export function subscribeConsent(fn: (s: ConsentState) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}